module.exports = __webpack_public_path__ + "static/media/ISR.6e47c571.svg";